import { TABLE_COLUMN_KEYS } from '../components/Table/consts';

export const TABLE_STYLES = {
  TableTitle: 'font-metricR text-sm text-bw07 mb-[12px]',
  TableTitleAddon: 'font-metricR text-sm text-bw06 ml-[5px]',
  TableRowWrapper: '',
  DueDateSubtitle: 'text-red02',
  TableTHead: 'top-0',
  TableHeaderWrapper: 'flex h-[40px] items-center border-t bg-bw00',
  TableLastRowStyle: 'rounded-s-lg',
  TableTH: 'p-0',
  TableHeaderCell: 'h-[40px] flex items-center align-middle bg-bw01 border-t border-b border-bw03 font-normal',
  TableHeaderCellText: 'text-sm text-bw07 font-metricR text-left',
  TableBodyCellText: 'text-sm text-bw08 font-metricR font-normal',
  TableBodyCell: 'h-[64px] border-b-[1px] border-bw03 flex flex-col justify-center box-border',
};

export const HEADER_CELL_STYLES = {
  [TABLE_COLUMN_KEYS.INVOICE]: `!pl-6 border-l border-bw03 rounded-tl-lg ${TABLE_STYLES.TableHeaderCell} ${TABLE_STYLES.TableHeaderCellText} flex-[0_0_13%]`,
  [TABLE_COLUMN_KEYS.CLIENT]: `${TABLE_STYLES.TableHeaderCell} ${TABLE_STYLES.TableHeaderCellText} flex-[1_0_30%]`,
  [TABLE_COLUMN_KEYS.DUEDATE]: `${TABLE_STYLES.TableHeaderCell} ${TABLE_STYLES.TableHeaderCellText} flex-[1_0_25%]`,
  [TABLE_COLUMN_KEYS.AMOUNT]: `${TABLE_STYLES.TableHeaderCell} ${TABLE_STYLES.TableHeaderCellText} flex-[0_0_14%] justify-end px-[10px]`,
  [TABLE_COLUMN_KEYS.STATUS]: `${TABLE_STYLES.TableHeaderCell} ${TABLE_STYLES.TableHeaderCellText} flex-[0_0_10%] justify-center`,
  [TABLE_COLUMN_KEYS.ACTION]: `pr-6 justify-center border-r border-bw03 rounded-tr-lg ${TABLE_STYLES.TableHeaderCell} ${TABLE_STYLES.TableHeaderCellText} flex-[0_0_8%] px-[10px]`,
};

export const BODY_CELL_STYLES = {
  [TABLE_COLUMN_KEYS.INVOICE]: `w-[145px] border-l-[1px] border-bw03 pl-6 ${TABLE_STYLES.TableBodyCell} ${TABLE_STYLES.TableBodyCellText}`,
  [TABLE_COLUMN_KEYS.CLIENT]: `${TABLE_STYLES.TableBodyCell} ${TABLE_STYLES.TableBodyCellText}`,
  [TABLE_COLUMN_KEYS.DUEDATE]: `${TABLE_STYLES.TableBodyCell} ${TABLE_STYLES.TableBodyCellText}`,
  [TABLE_COLUMN_KEYS.AMOUNT]: `w-[145px] ${TABLE_STYLES.TableBodyCell} ${TABLE_STYLES.TableBodyCellText} text-right px-[10px]`,
  [TABLE_COLUMN_KEYS.STATUS]: `w-[100px] ${TABLE_STYLES.TableBodyCell} ${TABLE_STYLES.TableBodyCellText} items-center`,
  [TABLE_COLUMN_KEYS.ACTION]: `w-[80px] pr-6 border-r-[1px] border-bw03 items-center ${TABLE_STYLES.TableBodyCell} ${TABLE_STYLES.TableBodyCellText} px-[10px]`,
};

export const WIDGET_MODE_BODY_CELL_STYLES = {
  [TABLE_COLUMN_KEYS.INVOICE]: `w-[128px] pl-3 h-[60px] flex flex-col justify-center box-border ${TABLE_STYLES.TableBodyCellText}`,
  [TABLE_COLUMN_KEYS.CLIENT]: `w-[152px] h-[60px] flex flex-col justify-center box-border ${TABLE_STYLES.TableBodyCellText}`,
  [TABLE_COLUMN_KEYS.DUEDATE]: `w-auto h-[60px] flex flex-col justify-center box-border ${TABLE_STYLES.TableBodyCellText}`,
  [TABLE_COLUMN_KEYS.STATUS]: `w-[119px] h-[60px] flex flex-col justify-center box-border ${TABLE_STYLES.TableBodyCellText} items-center`,
  [TABLE_COLUMN_KEYS.AMOUNT]: `w-full h-[60px] flex flex-col justify-center box-border ${TABLE_STYLES.TableBodyCellText} text-right px-[10px]`,
};
